/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';

import { edit, operations, test, locations, tools, resources, preferences, sales, images } from './controller';
import { sidebar } from '../controller';

export default (router) => {
    //router(`/connections/:connectionId/edit`, sidebar, edit, makeLayout, render);
    router(`/connections/:connectionId`, sidebar, edit, makeLayout, render);
    router(`/connections/:connectionId/syncs`, sidebar, operations, makeLayout, render);
    router(`/connections/:connectionId/locations`, sidebar, locations, makeLayout, render);
    router(`/connections/:connectionId/tools`, sidebar, tools, makeLayout, render);
    router(`/connections/:connectionId/preferences`, sidebar, preferences, makeLayout, render);
    router(`/connections/:connectionId/resources`, sidebar, resources, makeLayout, render);
    router(`/connections/:connectionId/sales`, sidebar, sales, makeLayout, render);
    router(`/connections/:connectionId/images`, sidebar, images, makeLayout, render);
};